'use client';

import { c as _c } from "react/compiler-runtime";
import { createContext, useContext, type ReactNode } from 'react';
import { formatVersionLabel, LOCAL_RELEASE } from '@/lib/settings/release';

/**
 * Runtime release identity for client components. The root layout (rendered
 * per request) reads `CRUCIBLE_RELEASE` / the slot on the server and passes
 * them in, so a slot swap shows the new release without a rebuild.
 */
export interface AppRelease {
  release: string;
  isStaging: boolean;
}
const AppReleaseContext = createContext<AppRelease>({
  release: LOCAL_RELEASE,
  isStaging: false
});
export function AppReleaseProvider(t0) {
  const $ = _c(6);
  const {
    release,
    isStaging,
    children
  } = t0;
  let t1;
  if ($[0] !== isStaging || $[1] !== release) {
    t1 = {
      release,
      isStaging
    };
    $[0] = isStaging;
    $[1] = release;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== children || $[4] !== t1) {
    t2 = <AppReleaseContext.Provider value={t1}>{children}</AppReleaseContext.Provider>;
    $[3] = children;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
}
export function useAppRelease() {
  return useContext(AppReleaseContext);
}

/** `<release> · <hash>` for the running build. */
export function useAppVersionLabel() {
  const $ = _c(2);
  const t0 = useAppRelease();
  let t1;
  if ($[0] !== t0.release) {
    t1 = formatVersionLabel(t0.release);
    $[0] = t0.release;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}